import { render, staticRenderFns } from "./DocsLeftMenu.vue?vue&type=template&id=1b3db9aa&"
import script from "./DocsLeftMenu.vue?vue&type=script&lang=js&"
export * from "./DocsLeftMenu.vue?vue&type=script&lang=js&"
import style0 from "./DocsLeftMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports